import { useQuery } from '@tanstack/react-query';
import { fetchThirdPartyInvoicing } from '../services/thirdPartyAgreement';
import { thirdPartyAgreementKeys } from './thirdPartyAgreementKeys';

export function useThirdPartyInvoicingQuery(vrm: string, reference: string, active = true) {
    return useQuery({
        queryKey: thirdPartyAgreementKeys.invoicing(vrm, reference),
        queryFn: () => fetchThirdPartyInvoicing(vrm, reference),
        enabled: active && vrm !== '' && reference !== '',
        retry: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
    });
}
